/** Único punto de verdad: credenciales del PACS activo. */
export function buildPacsBasicAuth(pacsConfig) {
  const user =
    pacsConfig && pacsConfig.USUARIO != null ? String(pacsConfig.USUARIO) : ''
  const pass =
    pacsConfig && pacsConfig.PASS != null ? String(pacsConfig.PASS) : ''
  if (!user) return null
  return 'Basic ' + btoa(`${user}:${pass}`)
}

export function pacsAuthHeaders(pacsConfig) {
  const auth = buildPacsBasicAuth(pacsConfig)
  return auth ? { Authorization: auth } : {}
}
